import { Directive, effect, ElementRef, inject, input, Renderer2 } from '@angular/core';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';

function coerceStringProperty(value: StringInput): string {
  return value?.toString() || '';
}

type StringInput = string | number | null | undefined;

@Directive({
  selector: '[ifBadge]',
  host: {
    class: 'relative',
  },
})
export class BadgeDirective {
  readonly ifBadge = input<string, StringInput>('', { transform: coerceStringProperty });
  readonly ifBadgeHidden = input<boolean, BooleanInput>(false, { transform: coerceBooleanProperty });

  private badgeElement: HTMLElement | null = null;

  private readonly badgeClasses = 'indicator indicator-primary indicator-pos size-5';

  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  constructor() {
    effect(() => this.updateBadge(this.ifBadge(), this.ifBadgeHidden()));
  }

  private updateBadge(badgeText: string, badgeHidden: boolean): void {
    if (this.badgeElement) {
      this.renderer.removeChild(this.el.nativeElement, this.badgeElement);
    }

    if (badgeHidden) {
      return;
    }

    this.badgeElement = this.renderer.createElement('span');
    this.renderer.addClass(this.badgeElement, 'indicator');
    this.renderer.appendChild(this.badgeElement, this.renderer.createText(badgeText));

    this.badgeClasses.split(' ').forEach(c => this.renderer.addClass(this.badgeElement, c));

    this.renderer.appendChild(this.el.nativeElement, this.badgeElement);
  }
}
